import { Popup, PopupProps, PopupRequiredProps } from 'lego-on-react';
import * as React from 'react';
import { MutableRefObject, useEffect, useRef } from 'react';

import { PopupScopeContext } from '../../service/Dom/Dom';
import { LazyVisible } from '../LazyVisible/LazyVisible';

// перехватывает событие при скроле, что б не скролился грид под попапом
// DIRECT-99852
const onScroll = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
};

export const ScopedPopup = React.memo(
    (
        props: PopupProps & PopupRequiredProps & { children: React.ReactNode }
    ) => {
        const popupRef: MutableRefObject<Popup | null> = useRef(null);

        useEffect(() => {
            let timeout: number;

            if (props.visible) {
                // таймаут нужен для исправления позиционирования попапа DIRECT-99878
                // forceUpdate - DIRECT-100910 (ISL-5001 костыль пока в лего не будут учитывать отрисовку body при перерисовки popup)
                timeout = window.setTimeout(() => {
                    if (popupRef.current !== null) {
                        popupRef.current.forceUpdate();
                    }
                }, 0);
            }

            return () => {
                window.clearTimeout(timeout);
            };
        }, [props.visible, props.children]);
        return (
            <PopupScopeContext.Consumer>
                {scope => {
                    const popupProps = { scope, ...props };

                    return (
                        <div onWheel={onScroll}>
                            <LazyVisible>
                                <Popup ref={popupRef} {...popupProps} />
                            </LazyVisible>
                        </div>
                    );
                }}
            </PopupScopeContext.Consumer>
        );
    }
);
